import { Component, Injector, OnInit, } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AboutSeecServiceProxy, HomeAboutDto } from '@shared/service-proxies/service-proxies';
@Component({
  selector: 'seek-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  animations: [appModuleAnimation()]
})
export class AboutComponent extends AppComponentBase implements OnInit {

  viewaboutSeec: HomeAboutDto = undefined;
  constructor(
    injector: Injector,
    private _aboutseecServiceProxy: AboutSeecServiceProxy,

    private _activatedRoute: ActivatedRoute,
    private _router: Router,
  ) {
    super(injector);
    this.viewaboutSeec = new HomeAboutDto();
  }

  ngOnInit() {
    this._aboutseecServiceProxy.getPublished().subscribe((aboutseecResult) => {
      this.viewaboutSeec = aboutseecResult;
    })
  }

}
